import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

const DEFAULT_WIDTH = 70;
const DEFAULT_HEIGHT = 40;
const CHECKOUT_METHOD_LIST_VARIANT = 'checkout-method-list';
const CHECKOUT_METHOD_CARD_VARIANT = 'checkout-method-card';

const MethodImage = ({ method, loading = 'lazy', variant = 'default' }) => {
  const [naturalDimensions, setNaturalDimensions] = useState(null);

  const imageSrc = method.logo || method.image;
  const imageAlt = method.name;
  const hasBackendDimensions =
    method.image_width != null && method.image_height != null;

  const w = method.image_width ?? naturalDimensions?.width ?? DEFAULT_WIDTH;
  const h = method.image_height ?? naturalDimensions?.height ?? DEFAULT_HEIGHT;

  const handleLoad = (e) => {
    if (!hasBackendDimensions) {
      setNaturalDimensions({
        width: e.target.naturalWidth,
        height: e.target.naturalHeight,
      });
    }
  };

  if (!imageSrc) {
    return null;
  }

  return (
    <div className={classNames('MethodImage', `MethodImage--${variant}`)}>
      <img
        className="MethodImage__image"
        src={imageSrc}
        alt={imageAlt}
        width={w}
        height={h}
        loading={loading}
        onLoad={handleLoad}
      />
    </div>
  );
};

MethodImage.propTypes = {
  method: PropTypes.shape({
    logo: PropTypes.string,
    image: PropTypes.string,
    name: PropTypes.string,
    image_width: PropTypes.number,
    image_height: PropTypes.number,
  }).isRequired,
  loading: PropTypes.string,
  variant: PropTypes.oneOf([
    'default',
    'large',
    CHECKOUT_METHOD_LIST_VARIANT,
    CHECKOUT_METHOD_CARD_VARIANT,
  ]),
};

export default MethodImage;
